import { useContext, useEffect, useState } from "react";
import axios from "axios";
import UserContext from "../../contexts/UserContext";
import Utils from "../../Utils";
import Loader from "../Loader";

const ManagePhotoshootsSection = () => {
  const { siteStatuses } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [photoshoots, setPhotoshoots] = useState([]);

  useEffect(() => {
    axios
      .get(Utils.apiUrl("photoshoot/activePhotoshoots"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setPhotoshoots(res.data.data || []);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getAttrArr = (hotelAttrs) => {
    if (!hotelAttrs) return [];
    return hotelAttrs.split("#");
  };

  const renderBell = (status) => {
    const redStatus = [0, 2, 3, 5, 7, 9, 11];
    return (
      <div>
        <i
          className={`fas fa-bell text-${redStatus.includes(Number(status)) ? "red" : "green"}-500`}
        ></i>{" "}
        {siteStatuses.statusToBe[Number(status) + 1]}
      </div>
    );
  };

  const renderBellToDo = (st) => {
    let todoBell = Utils.todoBell("PG", st);
    if (todoBell[1] === false) {
      return <></>;
    } else {
      return (
        <div className="flex items-center space-x-1">
          <i
            className={`fas fa-bell text-${todoBell[2] === 1 ? "red" : "green"}-500`}
          ></i>{" "}
          <div className={`statusLabel statusLabel1`}>{todoBell[1]}</div>
        </div>
      );
    }
  };

  return (
    <div className="dashboard-section">
      <div className="section-title">
        <i className="fas fa-camera-retro"></i>
        My Photoshoots
      </div>

      {loading && <Loader />}

      {!loading && photoshoots.length === 0 && (
        <div className="rounded bg-gray-100 p-3 text-center text-gray-600">
          No assigned photoshoots found.
        </div>
      )}

      {!loading && photoshoots.length > 0 && (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {photoshoots.map((record) => {
            const hotelAttrs = getAttrArr(record.hotel_attrs);

            return (
              <article key={record.id} className="project-tile bg-white">
                <div className="bg-white p-4">
                  <div className="flex items-start justify-between">
                    <div>
                      <h2 className="text-lg font-semibold text-gray-800">{`${hotelAttrs[0] || ""} - ${hotelAttrs[1] || ""}`}</h2>
                      <p className="mt-1 text-sm text-gray-500">
                        Type:{" "}
                        <span className="font-medium text-gray-700">
                          {Utils.getPhotoshootHotelTypeName(record.hotel_type)}
                        </span>
                      </p>
                      <p className="text-sm text-gray-500">
                        Shoot Date:{" "}
                        <span className="font-medium text-gray-700">
                          {formatDate(record.date_from)} -{" "}
                          {formatDate(record.date_to)}
                        </span>
                      </p>
                      <p className="text-sm text-gray-500">
                        Status:{" "}
                        <span className="font-medium text-gray-700">
                          {siteStatuses.status[record.status]}
                        </span>
                        {renderBellToDo(record.pg_todo)}
                      </p>
                    </div>
                  </div>

                  <div className="mt-4 flex space-x-3 text-xs">
                    {record.status === 0 && (
                      <a
                        href={`photoshoot-request/${record.id}`}
                        className="btn flex items-center space-x-2 rounded px-4 py-2 text-sm font-semibold text-white hover:opacity-90"
                      >
                        <i className="fa-regular fa-camera"></i>
                        <span>Verify Request</span>
                      </a>
                    )}

                    {record.status > 0 && (
                      <a
                        href={`photoshoot-details/${record.id}`}
                        className="btn inline-flex items-center justify-center rounded bg-gray-800 px-4 py-2 text-white hover:bg-gray-700"
                      >
                        <i className="fas fa-eye mr-2"></i> View Details
                      </a>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ManagePhotoshootsSection;
